import React from 'react';
import { Route, Routes} from 'react-router-dom';
import 'contents/assets/scss/styles.scss';

//loyout
import Header from '../views/html/component/Inc/Header.js';
//main
import Module from '../views/html/page/main/Module.js';
import Main from '../views/html/page/main/Index.js';
import Award from '../views/html/page/main/Award.js';
import MonthlyBestTeacher from '../views/html/page/main/MonthlyBestTeacher.js';
import MonthlyBestTeacherManage from '../views/html/page/main/MonthlyBestTeacherManage.js';
import IntroduceMember from '../views/html/page/main/IntroduceMember.js';
import SpeacialMember from '../views/html/page/main/SpeacialMember.js';
import NewMember from '../views/html/page/main/NewMember.js';
//member
import Login from '../views/html/page/member/Login.js';
import SearchId from '../views/html/page/member/SearchId.js';
import SearchPw from '../views/html/page/member/SearchPw.js';
import NewPw from '../views/html/page/member/NewPw.js';
//mypage - teacher
import Teacher from '../views/html/page/mypage/teacher/Index.js';
import Attendance from '../views/html/page/mypage/teacher/Attendance.js';
import AttendanceDetail from '../views/html/page/mypage/teacher/AttendanceDetail.js';
import AssignManage from '../views/html/page/mypage/teacher/AssignManage.js';
import MyAssignManageWeeks from '../views/html/page/mypage/teacher/AssignManageWeeks.js';
import ReceiveMail from '../views/html/page/mypage/teacher/ReceiveMail.js';
import SendMail from '../views/html/page/mypage/teacher/SendMail.js';
import SendMailDetail from '../views/html/page/mypage/teacher/SendMailDetail.js';
import Point from '../views/html/page/mypage/teacher/Point.js';
import Salary from '../views/html/page/mypage/teacher/Salary.js';
import SalarySchool from '../views/html/page/mypage/teacher/SalarySchool.js';
import Incentive from '../views/html/page/mypage/teacher/Incentive.js';
import ParkingFee from '../views/html/page/mypage/teacher/ParkingFee.js';
import CertificateRequest from '../views/html/page/mypage/teacher/CertificateRequest.js';
import MyInfo from '../views/html/page/mypage/teacher/MyInfo.js';
//mypage - ClassTeacher 담임
import ClassTeacher from '../views/html/page/mypage/classTeacher/Index.js';
import MyStudentList from '../views/html/page/mypage/classTeacher/MyStudentList.js';
import MyPayment from '../views/html/page/mypage/classTeacher/Payment.js';

//mypage - Employee
import Employee from '../views/html/page/mypage/employee/Index.js';
import WeeklyReport from '../views/html/page/mypage/employee/WeeklyReport.js';
import MeetingReport from '../views/html/page/mypage/employee/MeetingReport.js';
import EmployeePoint from '../views/html/page/mypage/employee/EmployeePoint.js';
import EmployeeInfo from '../views/html/page/mypage/employee/EmployeeInfo.js';
//student
import ClassStatistics from '../views/html/page/student/ClassStatistics.js';
import PRClassReport from '../views/html/page/student/PRClassReport.js';
import ClassRegister from '../views/html/page/student/ClassRegister.js';
import ClassRegisterDetail from '../views/html/page/student/ClassRegisterDetail.js';
import ClassRegisterExternal from '../views/html/page/student/ClassRegisterExternal.js';
import ClassProgressRequestExternal from '../views/html/page/student/ClassProgressRequestExternal.js';
import ClassSelectExternal from '../views/html/page/student/ClassSelectExternal.js';
import StudentList from '../views/html/page/student/StudentList.js';
import Assignment from '../views/html/page/student/Assignment.js';
import FirstClassReport from '../views/html/page/student/FirstClassReport.js';
import FinishReport from '../views/html/page/student/FinishReport.js';
import StudentRefund from '../views/html/page/student/Refund.js';
import TimeChange from '../views/html/page/student/TimeChange.js';
import SuspensionList from '../views/html/page/student/SuspensionList.js';
import EvaluationReport from '../views/html/page/student/EvaluationReport.js';
import StudentAttendance from '../views/html/page/student/Attendance.js';
import InterviewDate from '../views/html/page/student/InterviewDate.js';
import SchoolReport from '../views/html/page/student/SchoolReport.js';
import AttendanceSchool from '../views/html/page/student/AttendanceSchool.js';
import ClassPlan from '../views/html/page/student/ClassPlan.js';
import ShortReport from '../views/html/page/student/ShortReport.js';
import MentorReport from '../views/html/page/student/MentorReport.js';
import Satisfaction from '../views/html/page/student/Satisfaction.js';
import SatisfactionManage from '../views/html/page/student/SatisfactionManage.js';
import SatisfactioExternal from '../views/html/page/student/SatisfactioExternal.js';
import FinishClassPlan from '../views/html/page/student/FinishClassPlan.js';
import MonthlyReport from '../views/html/page/student/MonthlyReport.js';
import TestReport from '../views/html/page/student/TestReport.js';
import TestReportForm from '../views/html/page/student/TestReportForm.js';
import SchoolManage from '../views/html/page/student/SchoolManage.js';
import StudentSpeacialMember from '../views/html/page/student/SpeacialMember.js';
import HotLine from '../views/html/page/student/HotLine.js';
//-detail
import StudentDetail from '../views/html/page/student/detail/StudentDetail.js';
import InOutList from '../views/html/page/student/detail/InOutList.js';
import StudentBook from '../views/html/page/student/detail/Book.js';
import DetailFirstClassReport from '../views/html/page/student/detail/FirstClassReport.js';
import DetailEvaluationReport from '../views/html/page/student/detail/EvaluationReport.js';
import StudentDetailAttendance from '../views/html/page/student/detail/AttendanceDetail.js';
import DetailShortReport from '../views/html/page/student/detail/ShortReport.js';

//statistics
import Statistics from '../views/html/page/statistics/Index.js';
import StatisticsTeacher from '../views/html/page/statistics/Teacher.js';
import StatisticsSales from '../views/html/page/statistics/Sales.js';
import StatisticsTeacherProgress from '../views/html/page/statistics/Progress.js';
import JoinAndLeave from '../views/html/page/statistics/JoinAndLeave.js';
import DemonstrationLecture from '../views/html/page/statistics/DemonstrationLecture.js';
import Promotion from '../views/html/page/statistics/Promotion.js';
import PromotionCall from '../views/html/page/statistics/PromotionCall.js';
import SalesBook from '../views/html/page/statistics/SalesBook.js';
import SalesBookDetail from '../views/html/page/statistics/SalesBookDetail.js';

//community
import Community from '../views/html/page/community/Index.js';
import Notice from '../views/html/page/community/Notice.js';
//import Proposal from '../views/html/page/community/Proposal';
import Board from '../views/html/page/community/Board.js';
//import VideoClass from '../views/html/page/community/VideoClass';
import Photo from '../views/html/page/community/Photo.js';
import PhotoDetail from '../views/html/page/community/PhotoDetail.js';
import ReservationRoom from '../views/html/page/community/ReservationRoom.js';
//import FAQ from '../views/html/page/community/FAQ';
//import UrgentNotice from '../views/html/page/community/UrgentNotice';

// training
import EvaluationInterview from '../views/html/page/training/EvaluationInterview.js';
import EvaluationInterviewRegister from '../views/html/page/training/EvaluationInterviewRegister.js';
import LearnerTraining from '../views/html/page/training/LearnerTraining.js';
import TeacherTraining from '../views/html/page/training/TeacherTraining.js';
import TeacherTrainingDetail from '../views/html/page/training/TeacherTrainingDetail.js';
import TrainerManage from '../views/html/page/training/TrainerManage.js';
import VideoEvaluation from '../views/html/page/training/VideoEvaluation.js';
import VideoEvaluationRegister from '../views/html/page/training/VideoEvaluationRegister.js';
import TrainingNotice from '../views/html/page/training/Notice.js';
import TrainingAttendance from '../views/html/page/training/TrainingAttendance.js';
//import StudyTraining from '../views/html/page/training/StudyTraining';
//import Reason from '../views/html/page/training/Reason';
//import UrgentAssignment from '../views/html/page/training/UrgentAssignment';

//books
import BooksNotice from '../views/html/page/books/Notice.js';
import NoticeDetail from '../views/html/page/books/NoticeDetail.js';
//import Marketing from "../views/html/page/books/Marketing";
//import MarketingDetail from "../views/html/page/books/MarketingDetail";
//import PlanningBookReport from "../views/html/page/books/PlanningBookReport";
//import BooksMeetingReport from "../views/html/page/books/MeetingReport";
//import RequestMaking from "../views/html/page/books/RequestMaking";
//import RequestFeeList from "../views/html/page/books/RequestFeeList";
import InOut from '../views/html/page/books/InOut.js';
import InOutDetail from '../views/html/page/books/InOutDetail.js';
import InOutRequest from '../views/html/page/books/InOutRequest.js';
import Stock from '../views/html/page/books/Stock.js';
import BookPriceCalculate from '../views/html/page/books/BookPriceCalculate.js';
import Refund from '../views/html/page/books/Refund.js';
import RefundDetail from '../views/html/page/books/RefundDetail.js';
import RefundBook from '../views/html/page/books/RefundBook.js';
import BrochureStock from '../views/html/page/books/BrochureStock.js';

//promotion
import PRClass from '../views/html/page/promotion/PRClass.js';
import PromotionInquiry from '../views/html/page/promotion/Inquiry.js';
// import PRClassReport from '../views/html/page/promotion/PRClassReport';
// import PRClassReport2 from '../views/html/page/promotion/PRClassReport2';
import OnlineConsulting from '../views/html/page/promotion/OnlineConsulting.js';
import CallStatus from '../views/html/page/promotion/CallStatus.js';
import InboundTeam from '../views/html/page/promotion/InboundTeam.js';
import InboundTeamDetail from '../views/html/page/promotion/InboundTeamDetail.js';
import PRList from '../views/html/page/promotion/PRList.js';
import PRBooklet from '../views/html/page/promotion/PRBooklet.js';
import PRBookletStock from '../views/html/page/promotion/PRBookletStock.js';
import PRStudentList from '../views/html/page/promotion/PRStudentList.js';
import PromotionSendMail from '../views/html/page/promotion/SendMail.js';
import PromotionSendMailRejection from '../views/html/page/promotion/SendMailRejection.js';
import PRMaterials from '../views/html/page/promotion/PRMaterials.js';

//teacher
import TeacherList from '../views/html/page/teacher/List.js';
//import TeacherAssignManage from "../views/html/page/teacher/AssignManage/Index";
//import TeacherAssignManageDetail from "../views/html/page/teacher/AssignManage/Detail";
import TeacherPreparing from '../views/html/page/teacher/Preparing.js';
import TeacherMap from '../views/html/page/teacher/Map.js';
import TeacherStatistics from '../views/html/page/teacher/Statistics.js';
import TeacherStatisticsAssignment from '../views/html/page/teacher/StatisticsAssignment.js';
////import TeacherPoint from "../views/html/page/teacher/Point/Index";
//import TeacherPointDetail from "../views/html/page/teacher/Point/Detail";
//import TeacherMentorReport from '../views/html/page/teacher/MentorReport';
import TeacherFinishReport from '../views/html/page/teacher/FinishReport/Index.js';
//import TeacherFinishReportDetail from '../views/html/page/teacher/FinishReport/Detail';
import TeacherProgress from '../views/html/page/teacher/Progress.js';
import TeacherMentorManage from '../views/html/page/teacher/MentorManage/Index.js';
import TeacherMentorManageDetail from '../views/html/page/teacher/MentorManage/Detail.js';
import TeacherMentoring from '../views/html/page/teacher/Mentoring/Index.js';
import TeacherMentoringManage from '../views/html/page/teacher/Mentoring/Manage.js';
import TeacherCampaign from '../views/html/page/teacher/Campaign/Index.js';
import TeacherCampaignDetail from '../views/html/page/teacher/Campaign/Detail.js';
import TeacherCampaignCreate from '../views/html/page/teacher/Campaign/Create.js';
import TeacherContract from '../views/html/page/teacher/Contract.js';
//import TeacherNoClass from '../views/html/page/teacher/NoClass';
//import TeacherGood from '../views/html/page/teacher/Good';
//import TeacherParkingFee from '../views/html/page/teacher/ParkingFee';

//-detail
import TeacherClassInfo from '../views/html/page/teacher/detail/ClassInfo.js';
import TeacherClassSchedule from '../views/html/page/teacher/detail/ClassSchedule.js';
import TeacherInfo from '../views/html/page/teacher/detail/Info.js';
import TeacherDetailAssignManage from '../views/html/page/teacher/detail/AssignManage.js';
import TeacherYearStatistics from '../views/html/page/teacher/detail/YearStatistics.js';
import TeacherDetailPoint from '../views/html/page/teacher/detail/Point.js';
// import TeacherAssignManageDetail from "../views/html/page/teacher/detail/AssignManage";
import TeacherDetailIncentive from '../views/html/page/teacher/detail/Incentive.js';

//Manage
import ManageEmployee from '../views/html/page/manage/Employee.js';
import ManageEmployeeInfo from '../views/html/page/manage/EmployeeInfo.js';
import ManagePapers from '../views/html/page/manage/Papers.js';
import ManageCertificationRequest from '../views/html/page/manage/CertificateRequest.js';
import ManagePoint from '../views/html/page/manage/ManagePoint.js';
import ManagePointDetail from '../views/html/page/manage/ManagePointDetail.js';
import ManageWeeklyReport from '../views/html/page/manage/ManageWeeklyReport.js';
import ManageMeetingReport from '../views/html/page/manage/ManageMeetingReport.js';
import ManageParkingFee from '../views/html/page/manage/ManageParkingFee.js';
import ManageClass from '../views/html/page/manage/Class.js';
import ManageGradeClass from '../views/html/page/manage/GradeClass.js';
import ManageDiscount from '../views/html/page/manage/Discount.js';
import ManagePopup from '../views/html/page/manage/Popup.js';
import ManageBirthday from '../views/html/page/manage/Birthday.js';
import ManageDutyLog from '../views/html/page/manage/DutyLog.js';
import ManageChangeKey from '../views/html/page/manage/ChangeKey.js';
import ManageAccessSetting from '../views/html/page/manage/AccessSetting.js';

//Accounting
import AccountingMonth from '../views/html/page/accounting/Month/Index.js';
import AccountingMonthDetail from '../views/html/page/accounting/Month/Detail.js';
import AccountingSubject from '../views/html/page/accounting/Subject.js';
import AccountingSubjectDetail from '../views/html/page/accounting/SubjectDetail.js';
import AccountingSubjectUndeposited from '../views/html/page/accounting/SubjectUndeposited.js';
import AccountingRefund from '../views/html/page/accounting/Refund.js';
import AccountingCalculate from '../views/html/page/accounting/Calculate/Index.js';
import AccountingCalculateDetail from '../views/html/page/accounting/Calculate/Detail.js';
import AccountingCalculateDetailSub from '../views/html/page/accounting/Calculate/DetailSub.js';
import AccountingSalary from '../views/html/page/accounting/Salary/Index.js';
import AccountingSalaryDetail from '../views/html/page/accounting/Salary/Detail.js';
import AccountingSalaryDetailSub from '../views/html/page/accounting/Salary/DetailSub.js';
import AccountingIncentive from '../views/html/page/accounting/Incentive/Index.js';
import AccountingIncentiveDetail from '../views/html/page/accounting/Incentive/Detail.js';
import AccountingIncentiveDetail03 from '../views/html/page/accounting/Incentive/Detail03.js';
import AccountingIncentiveCheck from '../views/html/page/accounting/IncentiveCheck/Index.js';
import AccountingIncentiveCheckDetail from '../views/html/page/accounting/IncentiveCheck/Detail.js';
import AccountingIncentiveCheckDetail03 from '../views/html/page/accounting/IncentiveCheck/Detail03.js';
import AccountingParkingFee from '../views/html/page/accounting/ParkingFee.js';
import AccountingSendPaystub from '../views/html/page/accounting/SendPaystub.js';

//Data
import Data from '../views/html/page/data/Index.js';
import DataNotice from '../views/html/page/data/Notice.js';
import DataVideo from '../views/html/page/data/Video.js';
//import HistoryExam from "../views/html/page/data/HistoryExam";
import AnalysisExam from '../views/html/page/data/AnalysisExam.js';
import ExpectingExam from '../views/html/page/data/ExpectingExam.js';
import EasyPotList from '../views/html/page/data/EasyPotList.js';
import EasyPot from '../views/html/page/data/EasyPot.js';
//etc
// import Terms from '../views/html/page/etc/Terms.js';
// import Privacy from '../views/html/page/etc/Privacy.js';

function HtmlRouter() {


  return (
    <>
      <Header />
      <Routes>
        <Route path="/Module" element={<Module />} /> 	{/* 20250218 퍼블 추가 */}
        <Route path="/" element={<Main />} />
        <Route path="/Award" element={<Award />} />
        <Route path="/MonthlyBestTeacher" element={<MonthlyBestTeacher />} />
        <Route path="/MonthlyBestTeacher/Manage" element={<MonthlyBestTeacherManage />} />
        <Route path="/IntroduceMember" element={<IntroduceMember />} />
        <Route path="/SpeacialMember" element={<SpeacialMember />} />
        <Route path="/NewMember" element={<NewMember />} />
        {/* Member */}
        <Route path="/Member/Login" element={<Login />} />
        <Route path="/Member/SearchId" element={<SearchId />} />
        <Route path="/Member/SearchPw" element={<SearchPw />} />
        <Route path="/Member/NewPw" element={<NewPw />} />
        {/* Mypage */}
        <Route path="/Mypage/Teacher" element={<Teacher />} />
        <Route path="/Mypage/Attendance" element={<Attendance />} />
        <Route path="/Mypage/Attendance/Detail" element={<AttendanceDetail />} />
        <Route path="/Mypage/AssignManage" element={<AssignManage />} />
        <Route path="/Mypage/AssignManageWeeks" element={<MyAssignManageWeeks />} />
        <Route path="/Mypage/ReceiveMail" element={<ReceiveMail />} />
        <Route path="/Mypage/SendMail" element={<SendMail />} />
        <Route path="/Mypage/SendMail/Detail" element={<SendMailDetail />} />
        <Route path="/Mypage/Point" element={<Point />} />
        <Route path="/Mypage/Salary" element={<Salary />} />
        <Route path="/Mypage/SalarySchool" element={<SalarySchool />} />
        <Route path="/Mypage/Incentive" element={<Incentive />} />
        <Route path="/Mypage/ParkingFee" element={<ParkingFee />} />
        <Route path="/Mypage/CertificateRequest" element={<CertificateRequest />} />
        <Route path="/Mypage/MyInfo" element={<MyInfo />} />
        <Route path="/Mypage/ClassTeacher" element={<ClassTeacher />} />
        <Route path="/Mypage/Payment" element={<MyPayment />} />
        <Route path="/Mypage/MyStudentList" element={<MyStudentList />} />
        <Route path="/Mypage/Employee" element={<Employee />} />
        <Route path="/Mypage/WeeklyReport" element={<WeeklyReport />} />
        <Route path="/Mypage/MeetingReport" element={<MeetingReport />} />
        <Route path="/Mypage/EmployeePoint" element={<EmployeePoint />} />
        <Route path="/Mypage/EmployeeInfo" element={<EmployeeInfo />} />
        {/* Student */}
        <Route path="/Student/ClassStatistics" element={<ClassStatistics />} />
        <Route path="/Student/PRClassReport" element={<PRClassReport />} />
        <Route path="/Student/ClassRegister" element={<ClassRegister />} />
        <Route path="/Student/ClassRegister/Detail" element={<ClassRegisterDetail />} />
        <Route path="/Student/ClassRegister/External" element={<ClassRegisterExternal />} />
        <Route path="/Student/ClassProgressRequest/External" element={<ClassProgressRequestExternal />} />
        <Route path="/Student/ClassSelect/External" element={<ClassSelectExternal />} />
        <Route path="/Student/StudentList" element={<StudentList />} />
        <Route path="/Student/Assignment" element={<Assignment />} />
        <Route path="/Student/FirstClassReport" element={<FirstClassReport />} />
        <Route path="/Student/FinishReport" element={<FinishReport />} />
        <Route path="/Student/Refund" element={<StudentRefund />} />
        <Route path="/Student/TimeChange" element={<TimeChange />} />
        <Route path="/Student/SuspensionList" element={<SuspensionList />} />
        <Route path="/Student/EvaluationReport" element={<EvaluationReport />} />
        <Route path="/Student/Attendance" element={<StudentAttendance />} />
        <Route path="/Student/InterviewDate" element={<InterviewDate />} />
        <Route path="/Student/AttendanceSchool" element={<AttendanceSchool />} />
        <Route path="/Student/SchoolReport" element={<SchoolReport />} />
        <Route path="/Student/ClassPlan" element={<ClassPlan />} />
        <Route path="/Student/ShortReport" element={<ShortReport />} />
        <Route path="/Student/MentorReport" element={<MentorReport />} />
        <Route path="/Student/Satisfaction" element={<Satisfaction />} />
        <Route path="/Student/Satisfaction/Manage" element={<SatisfactionManage />} />
        <Route path="/Student/Satisfaction/External" element={<SatisfactioExternal />} />
        <Route path="/Student/FinishClassPlan" element={<FinishClassPlan />} />
        <Route path="/Student/MonthlyReport" element={<MonthlyReport />} />
        <Route path="/Student/TestReport" element={<TestReport />} />
        <Route path="/Student/TestReport/Form" element={<TestReportForm />} />
        <Route path="/Student/SchoolManage" element={<SchoolManage />} />
        <Route path="/Student/SpeacialMember" element={<StudentSpeacialMember />} />
        <Route path="/Student/HotLine" element={<HotLine />} />

        {/* Student Detail */}
        <Route path="/Student/Detail/Info" element={<StudentDetail />} />
        <Route path="/Student/Detail/InOutList" element={<InOutList />} />
        <Route path="/Student/Detail/Book" element={<StudentBook />} />
        <Route path="/Student/Detail/FirstClassReport" element={<DetailFirstClassReport />} />
        <Route path="/Student/Detail/EveluationReport" element={<DetailEvaluationReport />} />
        <Route path="/Student/Detail/Attendance" element={<StudentDetailAttendance />} />
        <Route path="/Student/Detail/ShortReport" element={<DetailShortReport />} />

        {/*teacher*/}
        <Route path="/Teacher/List" element={<TeacherList />} />
        {/*<Route path="/Teacher/AssignManage" element={<TeacherAssignManage />} />
        <Route path="/Teacher/AssignManage/Detail" element={<TeacherAssignManageDetail />} />*/}
        <Route path="/Teacher/Preparing" element={<TeacherPreparing />} />
        <Route path="/Teacher/Map" element={<TeacherMap />} />
        <Route path="/Teacher/Statistics" element={<TeacherStatistics />} />
        <Route path="/Teacher/Statistics/Assignment" element={<TeacherStatisticsAssignment />} />
        <Route path="/Teacher/FinishReport" element={<TeacherFinishReport />} />
        {/*<Route path="/Teacher/FinishReport/Detail" element={<TeacherFinishReportDetail />} />*/}
        {/*<Route path="/Teacher/Point" element={<TeacherPoint />} />
        <Route path="/Teacher/Point/Detail" element={<TeacherPointDetail />} />*/}
        <Route path="/Teacher/Progress" element={<TeacherProgress />} />
        <Route path="/Teacher/MentorManage" element={<TeacherMentorManage />} />
        <Route path="/Teacher/MentorManage/Detail" element={<TeacherMentorManageDetail />} />
        {/*<Route path="/Teacher/MentorReport" element={<TeacherMentorReport />} /> */}
        <Route path="/Teacher/Mentoring" element={<TeacherMentoring />} />
        <Route path="/Teacher/Mentoring/Manage" element={<TeacherMentoringManage />} />
        <Route path="/Teacher/Campaign" element={<TeacherCampaign />} />
        <Route path="/Teacher/Campaign/Detail" element={<TeacherCampaignDetail />} />
        <Route path="/Teacher/Campaign/Create" element={<TeacherCampaignCreate />} />
        <Route path="/Teacher/Contract" element={<TeacherContract />} />
        {/*<Route path="/Teacher/NoClass" element={<TeacherNoClass />} />
        <Route path="/Teacher/Good" element={<TeacherGood />} />
        <Route path="/Teacher/ParkingFee" element={<TeacherParkingFee />} />*/}
        {/* teacher Detail */}
        <Route path="/Teacher/Detail/ClassInfo" element={<TeacherClassInfo />} />
        <Route path="/Teacher/Detail/ClassSchedule" element={<TeacherClassSchedule />} />
        <Route path="/Teacher/Detail/Info" element={<TeacherInfo />} />
        <Route path="/Teacher/Detail/AssignManage" element={<TeacherDetailAssignManage />} />
        <Route path="/Teacher/Detail/YearStatistics" element={<TeacherYearStatistics />} />
        <Route path="/Teacher/Detail/Point" element={<TeacherDetailPoint />} />
        <Route path="/Teacher/Detail/Incentive" element={<TeacherDetailIncentive />} />

        {/* Statistics */}
        <Route path="/Statistics/Index" element={<Statistics />} />
        <Route path="/Statistics/Teacher" element={<StatisticsTeacher />} />
        <Route path="/Statistics/Sales" element={<StatisticsSales />} />
        <Route path="/Statistics/TeacherProgress" element={<StatisticsTeacherProgress />} />
        <Route path="/Statistics/JoinAndLeave" element={<JoinAndLeave />} />
        <Route path="/Statistics/DemonstrationLecture" element={<DemonstrationLecture />} />
        <Route path="/Statistics/Promotion" element={<Promotion />} />
        <Route path="/Statistics/PromotionCall" element={<PromotionCall />} />
        <Route path="/Statistics/SalesBook" element={<SalesBook />} />
        <Route path="/Statistics/SalesBook/Detail" element={<SalesBookDetail />} />
        {/* Community */}
        <Route path="/Community/Index" element={<Community />} />
        <Route path="/Community/Notice" element={<Notice />} />
        {/*<Route path="/Community/Proposal" element={<Proposal />} />*/}
        <Route path="/Community/Board" element={<Board />} />
        {/*<Route path="/Community/VideoClass" element={<VideoClass />} />*/}
        <Route path="/Community/Photo" element={<Photo />} />
        <Route path="/Community/Photo/Detail" element={<PhotoDetail />} />
        <Route path="/Community/ReservationRoom" element={<ReservationRoom />} />
        {/*<Route path="/Community/FAQ" element={<FAQ />} />
        <Route path="/Community/UrgentNotice" element={<UrgentNotice />} />*/}

        {/* Training */}
        <Route path="/Training/EvaluationInterview" element={<EvaluationInterview />} />
        <Route path="/Training/EvaluationInterview/Register" element={<EvaluationInterviewRegister />} />
        <Route path="/Training/LearnerTraining" element={<LearnerTraining />} />
        <Route path="/Training/TeacherTraining" element={<TeacherTraining />} />
        <Route path="/Training/TeacherTraining/Detail" element={<TeacherTrainingDetail />} />
        <Route path="/Training/TrainerManage" element={<TrainerManage />} />
        <Route path="/Training/VideoEvaluation" element={<VideoEvaluation />} />
        <Route path="/Training/VideoEvaluation/Register" element={<VideoEvaluationRegister />} />
        <Route path="/Training/Notice" element={<TrainingNotice />} />
        <Route path="/Training/Attendance" element={<TrainingAttendance />} />
        {/*<Route path="/Training/StudyTraining" element={<StudyTraining />} />
        <Route path="/Training/Reason" element={<Reason />} />
        <Route path="/Training/UrgentAssignment" element={<UrgentAssignment />} />*/}

        {/* Books */}
        <Route path="/Books/Notice" element={<BooksNotice />} />
        <Route path="/Books/Notice/Detail" element={<NoticeDetail />} />
        {/*<Route path="/Books/Marketing" element={<Marketing />} />*/}
        {/*<Route path="/Books/Marketing/Detail" element={<MarketingDetail />} />*/}
        {/*<Route
          path="/Books/PlanningBookReport"
          element={<PlanningBookReport />}
        />*/}
        {/*<Route path="/Books/MeetingReport" element={<BooksMeetingReport />} />*/}
        <Route path="/Books/InOut" element={<InOut />} />
        <Route path="/Books/InOut/Detail" element={<InOutDetail />} />
        <Route path="/Books/InOutRequest" element={<InOutRequest />} />
        <Route path="/Books/Stock" element={<Stock />} />
        {/*<Route path="/Books/RequestMaking" element={<RequestMaking />} />*/}
        <Route path="/Books/BookPriceCalculate" element={<BookPriceCalculate />} />
        <Route path="/Books/Refund" element={<Refund />} />
        <Route path="/Books/Refund/Detail" element={<RefundDetail />} />
        <Route path="/Books/RefundBook" element={<RefundBook />} />
        <Route path="/Books/BrochureStock" element={<BrochureStock />} />
        {/*<Route path="/Books/RequestFeeList" element={<RequestFeeList />} />*/}

        {/* Promotion */}
        <Route path="/Promotion/PRClass" element={<PRClass />} />
        <Route path="/Promotion/Inquiry" element={<PromotionInquiry />} />
        {/* <Route path="/Promotion/PRClassReport" element={<PRClassReport />} />
        <Route path="/Promotion/PRClassReport2" element={<PRClassReport2 />} /> */}
        <Route path="/Promotion/OnlineConsulting" element={<OnlineConsulting />} />
        <Route path="/Promotion/CallStatus" element={<CallStatus />} />
        <Route path="/Promotion/InboundTeam" element={<InboundTeam />} />
        <Route path="/Promotion/InboundTeam/Detail/:tabNumber" element={<InboundTeamDetail />} />
        <Route path="/Promotion/PRList" element={<PRList />} />
        <Route path="/Promotion/PRBooklet" element={<PRBooklet />} />
        <Route path="/Promotion/PRBookletStock" element={<PRBookletStock />} />
        <Route path="/Promotion/PRStudentList" element={<PRStudentList />} />
        <Route path="/Promotion/SendMail" element={<PromotionSendMail />} />
        <Route path="/Promotion/SendMail/Rejection" element={<PromotionSendMailRejection />} />
        <Route path="/Promotion/PRMaterials" element={<PRMaterials />} />

        {/* Manage */}
        <Route path="/Manage/Employee" element={<ManageEmployee />} />
        <Route path="/Manage/Employee/Info" element={<ManageEmployeeInfo />} />
        <Route path="/Manage/Papers" element={<ManagePapers />} />
        <Route path="/Manage/CertificationRequest" element={<ManageCertificationRequest />} />
        <Route path="/Manage/Point" element={<ManagePoint />} />
        <Route path="/Manage/Point/Detail" element={<ManagePointDetail />} />
        <Route path="/Manage/WeeklyReport" element={<ManageWeeklyReport />} />
        <Route path="/Manage/MeetingReport" element={<ManageMeetingReport />} />
        <Route path="/Manage/ParkingFee" element={<ManageParkingFee />} />
        <Route path="/Manage/Class" element={<ManageClass />} />
        <Route path="/Manage/GradeClass" element={<ManageGradeClass />} />
        <Route path="/Manage/Discount" element={<ManageDiscount />} />
        <Route path="/Manage/Popup" element={<ManagePopup />} />
        <Route path="/Manage/Birthday" element={<ManageBirthday />} />
        <Route path="/Manage/DutyLog" element={<ManageDutyLog />} />
        <Route path="/Manage/ChangeKey" element={<ManageChangeKey />} />
        <Route path="/Manage/AccessSetting" element={<ManageAccessSetting />} />

        {/* Accounting */}
        <Route path="/Accounting/Month" element={<AccountingMonth />} />
        <Route path="/Accounting/Month/Detail" element={<AccountingMonthDetail />} />
        <Route path="/Accounting/Subject" element={<AccountingSubject />} />
        <Route path="/Accounting/Subject/Detail" element={<AccountingSubjectDetail />} />
        <Route path="/Accounting/SubjectUndeposited" element={<AccountingSubjectUndeposited />} />
        <Route path="/Accounting/Refund" element={<AccountingRefund />} />
        <Route path="/Accounting/Calculate" element={<AccountingCalculate />} />
        <Route path="/Accounting/Calculate/Detail" element={<AccountingCalculateDetail />} />
        <Route path="/Accounting/Calculate/DetailSub" element={<AccountingCalculateDetailSub />} />
        <Route path="/Accounting/Salary" element={<AccountingSalary />} />
        <Route path="/Accounting/Salary/Detail" element={<AccountingSalaryDetail />} />
        <Route path="/Accounting/Salary/DetailSub" element={<AccountingSalaryDetailSub />} />
        <Route path="/Accounting/Incentive" element={<AccountingIncentive />} />
        <Route path="/Accounting/Incentive/Detail" element={<AccountingIncentiveDetail />} />
        <Route path="/Accounting/Incentive/Detail03" element={<AccountingIncentiveDetail03 />} />
        <Route path="/Accounting/IncentiveCheck" element={<AccountingIncentiveCheck />} />
        <Route path="/Accounting/IncentiveCheck/Detail" element={<AccountingIncentiveCheckDetail />} />
        <Route path="/Accounting/IncentiveCheck/Detail03" element={<AccountingIncentiveCheckDetail03 />} />
        <Route path="/Accounting/ParkingFee" element={<AccountingParkingFee />} />
        <Route path="/Accounting/SendPaystub" element={<AccountingSendPaystub />} />

        {/* Data */}
        <Route path="/Data/" element={<Data />} />
        <Route path="/Data/Notice" element={<DataNotice />} />
        <Route path="/Data/Video" element={<DataVideo />} />
        {/*<Route path="/Data/HistoryExam" element={<HistoryExam />} />*/}
        <Route path="/Data/AnalysisExam" element={<AnalysisExam />} />
        <Route path="/Data/ExpectingExam" element={<ExpectingExam />} />
        <Route path="/Data/EasyPotList" element={<EasyPotList />} />
        <Route path="/Data/EasyPot" element={<EasyPot />} />

        {/* <Route path="/etc/Terms" element={<Terms/>}/>
        <Route path="/etc/Privacy" element={<Privacy/>}/> */}
      </Routes>
    </>
  );
}

export default HtmlRouter;
